// src/components/auth/LoginModal.jsx
import { useEffect } from "react";
import LoginForm from "./LoginForm";

const LoginModal = ({
  open,
  onClose,
  onSuccess,
  redirectOverride = "/confirm-booking",
  title = "Log in to continue",
  subtitle = "Verify your mobile number or use Google to continue your booking.",
}) => {
  useEffect(() => {
    if (!open) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose?.();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[11000] flex items-end sm:items-center justify-center px-0 sm:px-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/45 backdrop-blur-[2px]"
        onClick={onClose}
      />

      {/* Mobile: bottom sheet | Desktop: centered modal */}
      <div className="relative w-full sm:max-w-md bg-white sm:rounded-3xl rounded-t-3xl shadow-2xl border border-gray-200 overflow-hidden animate-[fadeIn_.18s_ease-out]">
        {/* Handle for mobile */}
        <div className="sm:hidden flex justify-center pt-3">
          <span className="h-1.5 w-12 rounded-full bg-gray-300" />
        </div>

        {/* Header */}
        <div className="px-5 pt-4 pb-3 border-b border-gray-100">
          <div className="flex items-start justify-between gap-3">
            <div>
              <h2 className="text-lg font-bold text-gray-900">{title}</h2>
              {subtitle ? (
                <p className="mt-1 text-sm text-gray-500 leading-6">
                  {subtitle}
                </p>
              ) : null}
            </div>

            <button
              type="button"
              onClick={onClose}
              className="shrink-0 h-9 w-9 inline-flex items-center justify-center rounded-full border border-gray-200 text-gray-500 hover:text-gray-800 hover:bg-gray-50 transition"
              aria-label="Close login modal"
            >
              ✕
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="px-5 py-5 max-h-[85vh] overflow-y-auto">
          <LoginForm
            onSuccess={onSuccess}
            onClose={onClose}
            redirectOverride={redirectOverride}
            compact
            showGoogle
          />
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
